
import { useEffect, useState } from 'react'
import { useConnect } from 'wagmi'
import ButtonComp from '../../components/common/ButtonComp'
import bnbImg from "../../assets/images/wallet/binance.png"
import metamaskImg from "../../assets/images/wallet/metamask.png"
import { Loading, Toast } from 'react-vant';
const walletId = ["metaMaskSDK", "wallet.binance.com", "com.okex.wallet", "walletConnect"]
const WalletBtn = () => {
    const { connectors, connect, status } = useConnect()
    const [connectorList, setConnectorList] = useState([])
    useEffect(() => {
        const list: any = connectors.filter((item) => {
            if (walletId.includes(item.id)) {

                return item
            }

        })
        setConnectorList(list)
    }, [])
    let toast: any = null
    useEffect(() => {
        // if (status === "pending") {
        //     toast = Toast.loading({
        //         message: 'Loading...',
        //         forbidClick: true,
        //         duration: 0
        //     })
        // } else {
        //     if (toast) {
        //         toast.clear()
        //     }

        // }
    }, [status])



    return (

        <>
            {

                connectorList.length && connectorList.map((connector: any, index) => {
                    return (
                        <ButtonComp key={connector.uid} mt={20} width={192} callBack={() => { }}>
                            <div onClick={() => {

                                connect({ connector })

                            }} className="w-[192px] h-[100%] flex items-center relative justify-center gap-[10px] text-[16px] leading-[19px] text-[#fff] font-semibold">

                                {
                                    connector.icon && <img className='w-5 h-5' src={connector.icon}></img>
                                }
                                {
                                    !connector.icon && <img className='w-5 h-5 rounded-[5px]' src={connector.id === "metaMaskSDK" ? metamaskImg : connector.id === "walletConnect" ? "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFwAAABcCAMAAADUMSJqAAAAYFBMVEX///8IiPAAf+8Age8Afe8AhfAAg/AAe+/Q4vvB2fq20vnV5fu71vmJufaWwPb0+f6ixveszPjb6fzq8v3I3vtipfNzrfR8sfWDtfVOnfNWoPMgjPBBlvExkfHg7fxqqfSHBNEAAAACkUlEQVRoge2X2VaDMBCGYbKwyFJs2lKL+v5vaVjLZCNgL/Sc/HeeTj+/ToYkRFFISEhISEjIP845zfKmybP0/GLwW3VnnEzh7KN6fxm5fVDO4lUYp4/yFfyiIzw2hJMu+y36AcyEHvzh8zf4rw5s5Al/P7y6JbVaL3haHdQmW+g+pDsgn29rz73Z3flS6zaTkw4gp1z7p7CzNd9KSxhhXdsUQhRN28k/FPp1B7r+wKPN4TurVx8XF8AF5OIPbxKEJpW2ZucSz3+S+9OrZ8cZtLWppL6tVgUaf7ak01n78WarSeO5N/S0hx1Fp9ELWlfRJA87ejLRE4+vNf0PTHb1ZKID45vbakoOeI/0r+2id+rLrvEP1KdE6KuLi07GyRrqPhP3sqdA3I2qkruVzWJw0VM5esxFlxsS76xs58iKYfAcizxsdqwzdGZkx3Z3Me1lVvdyLDC4z2zpbt5AxfK0E/Mzu2zSmvuTbdmexWoPNrqXzwKu0Bv6/K7JPUNnB0nt3sMeWeAPT+sPNXehnEtaZ8r14aI/s8hdoWfaUc2xO/KmivdAt7oLqrJlwZqO2GBg2+m6t+Leop5Y7gJmembwRu6ITaz3DNR3Uune6Foxud/WBaZ+z8nRwlSqNymvqAMiWk4jd08M7lBib7hF0QX1IPX31twJuhuR4TxF7uzis5YW+rrF81mN/iEq8Lgz5ubpIMs94Gq+/VKxzVYmUvW20u0z6OiM6m2hg5e3kS7nBkWjE2+21neVrV2x/b37ZM4dOFKeS8P+7kzxdNe9+1zhoDdyt72ULO57vfsU4PAe6HDQu8+wZ7lepoa9Fg5495Hu7he1Fg71ZEyWbLwEtslhtrwgbxV4XLJDQkJCQkJC/lZ+ALvtGXrHhw8mAAAAAElFTkSuQmCC" : bnbImg} alt="" />
                                }
                                {connector.name}
                            </div>

                        </ButtonComp>
                    )

                })

            }
        </>

    )
}

export default WalletBtn